import Immutable from "immutable";

/**
 * A constructor for `requests` records to store in the state
 */
export default class RequestState extends Immutable.Record({
  /** @memberof RequestState# */
  isFailed: false,

  /** @memberof RequestState# */
  isResolved: false,

  /** @memberof RequestState# */
  result: undefined,

  /** @memberof RequestState# */
  pendingRequest: null,

  /**
   * @type {Immutable.Map}
   * @memberof RequestState
   * @instance
   */
  meta: Immutable.Map(),

  /** @memberof RequestState# */
  errorCode: null,

  /** @memberof RequestState# */
  errorData: Immutable.Map()
}) {
  /**
   * It's pending if it's not resolved nor failed
   *
   * @returns {Boolean}
   */
  get isPending() {
    return !this.isResolved && !this.isFailed;
  }
}
